/* tslint:disable */
/* eslint-disable */
import { AddressDisplayModel as AceXFoundPortalCoreCaqModelsAddressDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/address-display-model';
import { GlobalEnumsAceGemeinnuetzigkeit as AceXFoundPortalCoreEntitiesGlobalEnumsAceGemeinnuetzigkeit } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-gemeinnuetzigkeit';
import { GlobalEnumsAceRechtsform as AceXFoundPortalCoreEntitiesGlobalEnumsAceRechtsform } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-rechtsform';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { AddressDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsAddressDisplayModelFormGroup } from '@/api/model-index';

export interface IInstitutionDisplayModel {
  address?: AceXFoundPortalCoreCaqModelsAddressDisplayModel;
  bic?: null | string;
  gemeinnuetzigkeit?: AceXFoundPortalCoreEntitiesGlobalEnumsAceGemeinnuetzigkeit;
  gueltigkeitGemeinnuetzigkeitsbescheid?: null | string;
  iban?: null | string;
  id?: null | string;
  kontoinhaber?: null | string;
  name?: null | string;
  nameDesKreditInstituts?: null | string;
  rechtsform?: AceXFoundPortalCoreEntitiesGlobalEnumsAceRechtsform;
}
export class InstitutionDisplayModel extends BaseModel implements IInstitutionDisplayModel {
  address?: AceXFoundPortalCoreCaqModelsAddressDisplayModel;
  bic?: null | string;
  gemeinnuetzigkeit?: AceXFoundPortalCoreEntitiesGlobalEnumsAceGemeinnuetzigkeit;
  gueltigkeitGemeinnuetzigkeitsbescheid?: null | string;
  iban?: null | string;
  id?: null | string;
  kontoinhaber?: null | string;
  name?: null | string;
  nameDesKreditInstituts?: null | string;
  rechtsform?: AceXFoundPortalCoreEntitiesGlobalEnumsAceRechtsform;
}
class BaseInstitutionDisplayModelFormGroup extends FormGroup {
  private static _instance: InstitutionDisplayModelFormGroup;
  
  public static get Instance(): InstitutionDisplayModelFormGroup {
    this._instance = new InstitutionDisplayModelFormGroup({
      address: AceXFoundPortalCoreCaqModelsAddressDisplayModelFormGroup.Instance,
      bic: new FormControl(null),
      gemeinnuetzigkeit: new FormControl(null),
      gueltigkeitGemeinnuetzigkeitsbescheid: new FormControl(null),
      iban: new FormControl(null),
      id: new FormControl(null),
      kontoinhaber: new FormControl(null),
      name: new FormControl(null),
      nameDesKreditInstituts: new FormControl(null),
      rechtsform: new FormControl(null),
    });

    return this._instance;
  }
}


export class InstitutionDisplayModelFormGroup extends BaseInstitutionDisplayModelFormGroup {
  public get Address(): AceXFoundPortalCoreCaqModelsAddressDisplayModelFormGroup {
    return this.controls["address"] as AceXFoundPortalCoreCaqModelsAddressDisplayModelFormGroup;
  }
  public get Bic(): FormControl {
    return this.controls["bic"] as FormControl;
  }
  public get Gemeinnuetzigkeit(): FormControl {
    return this.controls["gemeinnuetzigkeit"] as FormControl;
  }
  public get GueltigkeitGemeinnuetzigkeitsbescheid(): FormControl {
    return this.controls["gueltigkeitGemeinnuetzigkeitsbescheid"] as FormControl;
  }
  public get Iban(): FormControl {
    return this.controls["iban"] as FormControl;
  }
  public get Id(): FormControl {
    return this.controls["id"] as FormControl;
  }
  public get Kontoinhaber(): FormControl {
    return this.controls["kontoinhaber"] as FormControl;
  }
  public get Name(): FormControl {
    return this.controls["name"] as FormControl;
  }
  public get NameDesKreditInstituts(): FormControl {
    return this.controls["nameDesKreditInstituts"] as FormControl;
  }
  public get Rechtsform(): FormControl {
    return this.controls["rechtsform"] as FormControl;
  }
  

}

export module InstitutionDisplayModelForm
  {
    export class FormFields
    {
      static _address: string = "address";
      static _bic: string = "bic";
      static _gemeinnuetzigkeit: string = "gemeinnuetzigkeit";
      static _gueltigkeitGemeinnuetzigkeitsbescheid: string = "gueltigkeitGemeinnuetzigkeitsbescheid";
      static _iban: string = "iban";
      static _id: string = "id";
      static _kontoinhaber: string = "kontoinhaber";
      static _name: string = "name";
      static _nameDesKreditInstituts: string = "nameDesKreditInstituts";
      static _rechtsform: string = "rechtsform";
    }
  }

